export default function Wordmark({ size = 'md' }: { size?: 'md' | 'lg' }) {
  const cls = size === 'lg' ? 'text-4xl' : 'text-2xl';
  return (
    <div className="flex items-center gap-3">
      <span className="inline-block w-8 h-8 rounded-full bg-ball-400 shadow-glow shrink-0" />
      <div className={`${cls} font-semibold leading-none tracking-tight`}>
        BB <span className="text-ball-400">Commercial</span>
      </div>
    </div>
  );
}
